var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 159,
    viewBox: "0 0 150 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 72.8227V11.8681C6.5 6.74206 10.6977 2.58643 15.8758 2.58643H69.7864C74.9644 2.58643 79.1621 6.74206 79.1621 11.8681V138.718C79.1621 143.844 74.9644 148 69.7864 148H15.8758C10.6977 148 6.5 143.844 6.5 138.718V72.8227Z",
    stroke: "#00A0A3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02075 118.351H78.2505",
    stroke: "#00A0A3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0263 127.179C46.0448 127.179 48.4955 129.606 48.4955 132.594C48.4955 135.582 46.0448 138.009 43.0263 138.009C40.0079 138.009 37.5571 135.582 37.5571 132.594C37.5571 129.606 40.0079 127.179 43.0263 127.179Z",
    fill: "#00A0A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0263 127.179C46.0448 127.179 48.4955 129.606 48.4955 132.594C48.4955 135.582 46.0448 138.009 43.0263 138.009C40.0079 138.009 37.5571 135.582 37.5571 132.594C37.5571 129.606 40.0079 127.179 43.0263 127.179Z",
    fill: "#00A0A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0806 6.84143C63.0806 8.79794 61.4759 10.3865 59.4995 10.3865H26.3589C24.3825 10.3865 22.7778 8.79794 22.7778 6.84143C22.7778 4.88492 24.3825 3.29639 26.3589 3.29639H59.4995C61.4759 3.29639 63.0806 4.88492 63.0806 6.84143Z",
    fill: "#00A0A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0806 6.84143C63.0806 8.79794 61.4759 10.3865 59.4995 10.3865H26.3589C24.3825 10.3865 22.7778 8.79794 22.7778 6.84143C22.7778 4.88492 24.3825 3.29639 26.3589 3.29639H59.4995C61.4759 3.29639 63.0806 4.88492 63.0806 6.84143Z",
    fill: "#00A0A3",
    stroke: "#00A0A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9059 34.5577C94.4837 37.3747 94.5814 41.347 95.5292 42.2459C96.8257 43.4758 98.3425 44.928 98.3425 44.928C98.3425 44.928 92.7419 39.228 88.2418 40.1329C82.8032 41.2266 80.6403 45.122 81.4703 48.4443C82.6102 53.0074 91.4271 57.7231 91.4271 57.7231C91.4271 57.7231 80.5753 49.0416 74.649 48.8573C70.1472 48.7171 66.5234 54.1946 70.6071 59.0669C74.5999 63.8308 83.9802 69.9305 83.9802 69.9305L54.6079 45.2429C54.6079 45.2429 47.8403 43.3804 45.1147 47.7193C42.5589 51.7875 44.3473 56.3064 47.1219 58.1737C49.8965 60.041 79.2846 85.2949 91.039 92.7217C90.228 95.1561 67.7361 100.379 63.5593 104.778C59.3824 109.177 62.7516 118.264 71.9594 115.965C83.4596 113.094 117.636 104.778 117.636 104.778C117.636 104.778 127.721 102.276 136.236 86.8427C142.516 75.4621 144.827 67.1125 136.323 55.0712C131.783 48.6434 106.503 32.9357 106.503 32.9357C106.503 32.9357 100.823 30.0009 96.9059 34.5577Z",
    fill: "#252121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9059 34.5577C94.4837 37.3747 94.5814 41.347 95.5292 42.2459C96.8257 43.4758 98.3425 44.928 98.3425 44.928C98.3425 44.928 92.7419 39.228 88.2418 40.1329C82.8032 41.2266 80.6403 45.122 81.4703 48.4443C82.6102 53.0074 91.4271 57.7231 91.4271 57.7231C91.4271 57.7231 80.5753 49.0416 74.649 48.8573C70.1472 48.7171 66.5234 54.1946 70.6071 59.0669C74.5999 63.8308 83.9802 69.9305 83.9802 69.9305L54.6079 45.2429C54.6079 45.2429 47.8403 43.3804 45.1147 47.7193C42.5589 51.7875 44.3473 56.3064 47.1219 58.1737C49.8965 60.041 79.2846 85.2949 91.039 92.7217C90.228 95.1561 67.7361 100.379 63.5593 104.778C59.3824 109.177 62.7516 118.264 71.9594 115.965C83.4596 113.094 117.636 104.778 117.636 104.778C117.636 104.778 127.721 102.276 136.236 86.8427C142.516 75.4621 144.827 67.1125 136.323 55.0712C131.783 48.6434 106.503 32.9357 106.503 32.9357C106.503 32.9357 100.823 30.0009 96.9059 34.5577Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_74",
    x: 0,
    y: 0.0864258,
    width: 148.366,
    height: 158.414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_74"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_74",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.98a5f11eb0c9bd26ece9b60d4e67680c.svg";
export { ForwardRef as ReactComponent };